import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Article from "../components/Article";
import "../css/Weblog.css";
import WeblogSidebar1 from "../components/WeblogSidebar1";
import WeblogSidebar2 from "../components/WeblogSidebar2";
import { useEffect, useRef, useState, version } from "react";
import { Toast } from "primereact/toast";
import { Helmet } from "react-helmet";
import Pagination from "../components/Pagination";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import DownloadHTML from "../components/DownloadHTML";
import { apiClient } from "../apiClient";
import colors from '../colors';



function Weblog(props)
{

    const navigate = useNavigate();
    const user = localStorage.getItem('seo_app')? JSON.parse(localStorage.getItem('seo_app')): { username: "", name: "", avatarPic: "profile-index.png" };
    const [fetchedArticles,setFetchedArticles] = useState([]);
    const token = JSON.parse(localStorage.getItem('userToken'));
    const config = {  headers: {"Content-Type": "application/json",Authorization: `Bearer ${token}`} };
    const location = useLocation();
    const {article_slug }=useParams();
    const [relatedArticles,setRelatedArticles] = useState([]);
    const [updateArticles,setUpdateArticles] = useState(0);
    const toast = useRef(null);
    const { page } = useParams();
    const [currentPage, setCurrentPage] = useState(() => Number(page) || 1);
    const [totalPages, setTotalPages] = useState(1);
    const articlesPerPage = 10;
    const [desktop, setDesktop] = useState(window.matchMedia("(min-width: 768px)").matches);
    const articleRows = [];
    const [theme,setTheme] = useState(props.theme);
    const [themeSwitch,setThemeSwitch] = useState(props.theme==="light" ? true : false);
    const [internalLinksCreated,setInternalLinksCreated]= useState(false);
    const [showDownloadHTML,setShowDownloadHTML] = useState(false);
      
      // Group articles into pairs
      for (let i = 0; i < fetchedArticles.length; i += 2) {
        articleRows.push(fetchedArticles.slice(i, i + 2));
      }

      //update user theme:
const updateTheme = async () =>
  {
                const t = !themeSwitch;
                setThemeSwitch(t);
                props.setTheme(t ? "light" : "dark");
                setTheme(t ? "light" : "dark");
  
                const data = JSON.stringify({theme:t ? "light" : "dark"});
      
                  apiClient.patch(process.env.REACT_APP_BACK+"/settings/theme/"+user._id, data, config)
                  .then((response) => {
  
                  if(response.status == 200)
                  {
                    console.log(response);
                  }
                  })
                  .catch((error) => {
                    console.log("error",error);
                 
                  });
  
  }


      //calculate total pages:
      useEffect( () => {
        
        async function fetchData() {
          await apiClient.get(process.env.REACT_APP_BACK+"/articles/articles_count", config)
            .then((result) => {
              if (result.status == 200) {
                setTotalPages(Math.ceil(result.data / articlesPerPage));
                
               
              }
            })
        }
        fetchData();
        
      
        
      }, []);



      


      //fetch all articles:
    useEffect(() => {
      
        async function fetchArticles() {

          
          await apiClient.get(process.env.REACT_APP_BACK+"/articles/all/"+(currentPage*10), config)
            .then((result) => {
              if (result.status == 200) {
                setFetchedArticles(result.data);
                
                return result.data;
              }
            })
            .catch((error) => {
              console.log(error);
              if(error.response.data.statusCode===401)
                      navigate("/login");
           
            });
  
        }

// fetch single article:
        async function fetchSingleArticle() {

            
          await apiClient.get(process.env.REACT_APP_BACK+"/articles/articleBySlug/"+article_slug, config)
            .then((result) => {
              if (result.status == 200) {
                const temp = [result.data]
                setFetchedArticles(temp);
                
                
                return result.data;
              }
            })
            .catch((error) => {
              console.log(error);
              if(error.response.data.statusCode===401)
                      navigate("/login");
             
            });
  
        }

        //fetch related articles:
        async function fetchRelatedArticles()
        {
          apiClient
          .get(process.env.REACT_APP_BACK+"/articles/all/"+3, config)
          .then((result) => {
              if (result.status == 200) {
              setRelatedArticles(result.data);
              return result.data;

              }
          })
          .catch((error) => {
              console.log(error);
              if(error.response.data.statusCode===401)
                      navigate("/login");
           
          });
        }
  

        
        if(!props.singleArticle)
          fetchArticles();
        
        //single article:
        else
        {
          const {article} = location.state || {};
          
          if(!article)
            fetchSingleArticle();
          else
          {
            const temp = [article]
            setFetchedArticles(temp);
          }

          fetchRelatedArticles();
        }
      
    }, [updateArticles,currentPage]);

    const refreshArticlePage = () =>
    {
      setUpdateArticles(updateArticles+1); 
    }
    


    //delete article:
    const deleteArticleFromDB = async (_id) => 
      {
        await apiClient.delete(process.env.REACT_APP_BACK+"/articles/" + _id, config)
        .then(response => 
          {
            if (response.status == 200)
            {
              console.log(response);    
              if(props.singleArticle)
                navigate("/weblog")  ;
              
              toast.current.show({severity: 'info', summary: 'مقاله حذف شد'});
              refreshArticlePage();
              
            }
  
        })
        .catch(error => {
           console.log(error);
            if(error.response.data.statusCode===401)
                      navigate("/login");
          
        });
      };

      //making internal links to 2 tags and 1 article:
      const createInternalLinks = async (selectedLinksToArticles) => {

  

        // Where to put the link:
        let numberOfParaghraph = 1;
        let content = fetchedArticles[0]?.content; // Start with the initial content
    
        // Process articles:
        for (const article of selectedLinksToArticles.slice(0, 3)) {
            try {

                const result = await apiClient.get(`${process.env.REACT_APP_BACK}/articles/addInternalLinkTo/${article}`, config);
                if (result.status === 200) {
                  
                  // get the least reffered s keyword:

                    const keyword = result.data.keyword;


                    
                    const slug = result.data.slug;
                    const creator = result.data.creator;
                    content = addLinkToContent(content,keyword, `/articles/user_${
                      creator}/${slug}`, numberOfParaghraph);


                    //save content:
                    saveContent(content);


                    numberOfParaghraph+=2;
                    
                }
            } catch (error) {
                console.log(error);
                if(error.response.data.statusCode===401)
                      navigate("/login");
             
            }
        }
    
        // Update the form content once after all processing
        refreshArticlePage();
        
    };
    
    
    const addLinkToContent = (content,keyword, link, numberOfParagraph) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(content, 'text/html');
        const paragraphs = doc.querySelectorAll('p');
    
        paragraphs.forEach((p, index) => {
            
            if ((index + 1) === numberOfParagraph) {
                // Create an <a> element and set its attributes
                const anchor = document.createElement('a');
                anchor.href = link;
                anchor.textContent = "[" + keyword + "]";
    
                // Add a space and then append the <a> element to the paragraph
                p.appendChild(document.createTextNode(' '));
                p.appendChild(anchor);
                console.log("number of p:",numberOfParagraph);
            
            }
        });
    
        return doc.body.innerHTML;
    };

    const saveContent = (content) =>
    {             
                
                  var data = {content: content,internalLinksCreated:true};
     
                  apiClient.patch(process.env.REACT_APP_BACK+"/articles/updateContent/"+fetchedArticles[0]?._id, data, config)
                  .then(async (response) => {
  
                  if(response.status == 200)
                  {
                    await setInternalLinksCreated(true);
                    console.log(response);
                  }
                  })
                  .catch((error) => {
                    console.log("error",error);
                  
                  });
    }

    
      

    return(

  
        <span id="weblog" >
          
          
{/* meta tags: ********************************************************************************************************/}
        
            {props.singleArticle &&
             (

                <Helmet>
                
                <title>{fetchedArticles[0]?.title}</title>
                <meta name="description" content={fetchedArticles[0]?.metaDescription}/>
                <meta name="robots" content="index, follow"/>
                <meta name="author" content={fetchedArticles[0]?.creator?.name || "Unknown"}/>
                <link rel="canonical" href={`${process.env.REACT_APP_SITE_URL}/weblog/${fetchedArticles[0]?.slug}`}/>
                <meta property="og:title" content={fetchedArticles[0]?.title}/>
                <meta property="og:description" content={fetchedArticles[0]?.metaDescription}/>
                <meta property="og:image" content={`${process.env.REACT_APP_BACK}/articles/${fetchedArticles[0]?.indexedImage}`}/>
                <meta property="og:url" content={`${process.env.REACT_APP_SITE_URL}/weblog/${fetchedArticles[0]?.slug}`}/>
                <meta property="og:type" content="article"/>
                <meta property="article:published_time" content={fetchedArticles[0]?.createdDate || "2024-07-28"}/>
                <meta property="article:author" content={fetchedArticles[0]?.creator?.name || "Unknown"}/>
                <meta name="twitter:card" content="summary_large_image"/>
                <script type="application/ld+json">
                  {JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "Article",
                    "headline": fetchedArticles[0]?.title,
                    "description": fetchedArticles[0]?.metaDescription,
                    "author": {
                      "@type": "Person",
                      "name": fetchedArticles[0]?.creator?.name || "Unknown"
                    },
                    "publisher": {
                      "@type": "Organization",
                      "name": "Example Publisher",
                      "logo": {
                        "@type": "ImageObject",
                        "url": "https://www.example.com/logo.jpg"
                      }
                    },
                    "datePublished": fetchedArticles[0]?.createdDate || "2024-07-28"
                  })}
                </script>
                </Helmet>


          )}
{/**********************************************************************************************************************/}
     
        <Toast ref={toast}></Toast>

              <Dialog
                 className={props.theme}
                     id="download-html-dialog"
                     style={{width:"80%"}}
                     visible={showDownloadHTML}
                     onHide={() => {setShowDownloadHTML(false); }}
                     >
                 
               
             
                 <DownloadHTML article_id={fetchedArticles[0]?._id} />
           
                 </Dialog>

            {/* articles: */}
            <span id="weblogMainPanel">

            <div id="weblog-container">

            <span id="weblog-nav" style={{width:"100%",flexDirection:'row',display:"flex" , direction:'rtl'}}>
              <Link to="/dashboard"><p>داشبورد کاربران</p></Link>
              <p style={{marginRight:'10px',marginLeft:'10px'}}> > </p>
              <Link to="/dashboard/articles"><p style={{color: !props.singleArticle ? "#af734f" : null}}>مدیریت مقاله ها</p></Link>
              
              {props.singleArticle &&
              (<span style={{display:'flex'}}>
              <p style={{marginRight:'10px',marginLeft:'10px'}}> > </p>
              <p style={{marginLeft:'10px',color:'#219B9D'}}> {fetchedArticles[0]?.title} </p>
              </span>)}

            </span>

            

          {!props.singleArticle ?
            <h1 className="mainTitle">وبلاگ</h1>

            : 
            <span id="article-first-row" style={{display:'flex', direction:'rtl', alignItems:'center',gap:'30px'}}>
              <h1 className="mainTitle" style={{marginTop:'0px',display:'flex',width:'85%'}}>{fetchedArticles[0]?.title}</h1>
              <span style={{display:'flex',width:'15%',float:'left'}}>
                <Button id="downloadhtmlbutton"
                  onClick={() => setShowDownloadHTML(true)}
                  >دانلود کد html</Button></span>
              </span>
          }             
          
            

            { !props.singleArticle ?
            <p className="subtitle">
              با وبلاگ حرف به حرف همراه باشید تا شما را با آخرین اخبار و نکات مهم دنیای تولید محتوا و سئو آشنا کنیم.
              </p>
            : 
            null
            }
            
            <div style={{ width: '100%' }}>


              {/* multiple articles: */}
              {!props.singleArticle ?

                  articleRows.map((row, rowIndex) => (
                    <div key={rowIndex} style={{ display: desktop ? 'flex' : 'block', width: '100%' , gap: '30px'}}
                    className="multiple_article">
                      {row.map((article, index) => (
                        <div key={index} style={{ width: desktop ? '50%' : "100%", display: 'flex'}}>
                          <Article
                            key={fetchedArticles[0]?._id + "_" + updateArticles}
                            article={article}
                            singleArticle={false}
                            deleteArticleFromDB={deleteArticleFromDB}
                          
                            
                          />
                        </div>
                      ))}
                    </div>
                  ))

                  : 
                  // single article:
                  fetchedArticles.map((article, index) => (
                    <div key={index} style={{ width: '100%', display: 'flex'}}>

                      
                      <Article
                        key={fetchedArticles[0]?._id + "_" + updateArticles}
                        article={article}
                        singleArticle={true}
                        deleteArticleFromDB={deleteArticleFromDB}
                      />

                      

                    </div>
                  ))}

                
                </div>


              {props.singleArticle &&  fetchedArticles[0]?.type !== "user" &&
             (<div id="related-articles">
                <h3 >بیشتر بخوانید</h3>

                <div style={{display: desktop ? 'flex' : ' block',gap:'30px'}}>
                {relatedArticles.map((article, index) => (
                

                <Link  key={index} className="other_articles" to={"/weblog/"+article._id} >
                <li style={{marginBottom:'20px'}}>
                    <div>
                        <img 
                            src={`${process.env.REACT_APP_BACK}/articles/${article.indexedImage}`}
                            alt={process.env.REACT_APP_ALT}
                        ></img>
                        <h3>{article.title}</h3>
                        <p>{article.metaDescription+" ..."}</p>
                    </div>
                </li>
                </Link>

            ))}
            </div>

             </div>)}



        
        { !props.singleArticle && (totalPages > 1) &&
              (<div id="paging-section">
              
              <Pagination currentPage={currentPage} totalPages={totalPages} type={"weblog"}/>
              
              </div>)}



            </div>

            </span>

            
            

            {/* single article: */}

            {props.singleArticle ?
                
                <WeblogSidebar1 
                    className="no-scrol"  
                    singleArticle={props.singleArticle}
                    keyword={fetchedArticles[0]?.keyword}
                    secondryKeywords={fetchedArticles[0]?.secondryKeywords}
                    article_id={fetchedArticles[0]?._id}
                    metaDescription={fetchedArticles[0]?.metaDescription}
                    rank={fetchedArticles[0]?.rank}
                    createInternalLinks={createInternalLinks}
                    internalLinkToArticles={fetchedArticles[0]?.internalLinkToArticles}
                    internalLinksCreated={fetchedArticles[0]?.internalLinksCreated} 
                    creator={fetchedArticles[0]?.creator}
                    imagesHasWatermark={fetchedArticles[0]?.imagesHasWatermark}
                    imagesHasBackup={fetchedArticles[0]?.imagesHasBackup}
                    refreshArticlePage={refreshArticlePage}
                    >

                    </WeblogSidebar1>

                    :
                   
            <WeblogSidebar2 className="no-scrol"></WeblogSidebar2>
                    }


        </span>

        
    );
}

export default Weblog;